import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import "./context_components.css";
import { Collapse, Stack } from "@mui/material";
import ColorPicker from './color_picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useDispatch, useSelector } from "react-redux";
import { analysisActions } from "../../store/store";



export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgb(61,162,131)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(61,162,131)",
    maxWidth: "7rem"
  },
}));

export default function Selector(props) {
  const { value, type } = props;
  const dispatch = useDispatch();
  const {
    linearAnalysis,
    drillDownAnalysis
  } = useSelector(state => state.analysisStore);

  let analysis = (type === "linearAnalysis") ? linearAnalysis : drillDownAnalysis;
  const [color, setColor] = useState(!analysis.colors[value] ? analysis.colors[value] : "rgb(0, 255, 179)");

  useEffect(() => {
    let colors = {...analysis.colors};
    colors[value] = "rgb(0, 255, 179)";
    dispatch(analysisActions.changeColor({
      analysis: (type === "linearAnalysis") ? "linearAnalysis" : "drillDownAnalysis",
      value: colors
    }))
  }, [])

  useEffect(() => {
    setColor(analysis.colors[value] !== undefined ? analysis.colors[value] : "rgb(0, 255, 179)")
  }, [color, analysis])

  const changeColor = (e) => {
    let colors = {...analysis.colors};
    colors[value] = e.color;
    dispatch(analysisActions.changeColor({
      analysis: (type === "linearAnalysis") ? "linearAnalysis" : "drillDownAnalysis",
      value: colors
    }))
  }

  const handleRemoveItem = () => {
    props.onClick(value)
  }

  return (
    <Stack 
      direction="row"
      spacing={2}
      className="selector"
    >
      <BootstrapTooltip title={`${value}`} placement="top">
        <span className="selector-text">{value}</span>
      </BootstrapTooltip>
      <FontAwesomeIcon 
        className="selector-icon" 
        icon={faXmark} 
        onClick={handleRemoveItem}
      />
      <ColorPicker
        type="ai-boxes"
        color={color}
        changeColor={changeColor}
      />
    </Stack>
  );
}
